import { render, staticRenderFns } from "./VeritasCadets.vue?vue&type=template&id=54a4fbe9&scoped=true"
import script from "./VeritasCadets.vue?vue&type=script&lang=js"
export * from "./VeritasCadets.vue?vue&type=script&lang=js"
import style0 from "./VeritasCadets.vue?vue&type=style&index=0&id=54a4fbe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a4fbe9",
  null
  
)

export default component.exports